module.exports = __webpack_public_path__ + "img/ticket-big.510a5bd1.svg";